<template lang="pug" id="post-modal">
transition(name="modal-fade")
  .admin-modal-backdrop(role="dialog" v-if="data" @click.stop="close")
    template(v-if="name === 'box_account' || name === 'edit_box_account'")
      .admin-modal.column(@click.stop)
        .modal-content
          .header.row.center.right(v-if="$root.mobile")
            .icon.close(@click.stop="close")
              font-awesome-icon(icon="times")
          fieldset.column
            label {{ t.box_account_name }}
            input.text(v-model="data.name")
          fieldset.column
            label Logo
            .row.center.left
              .account-logo
                img(v-if="data.logo" v-storage="data.logo")
              input(type="file" id="logo-upload" ref="file" @change="upload")
          fieldset.column
            label {{ t.add_users }}
            multi-select(:data="$root.users.filter(d => d.role !== 'admin' && ($root.admin || d.role === 'client')).map((v, k) => v.name).vls()" :value="data.users && data.users.map(d => $root.users[d].name) || []" @change="update_users($event)")

          fieldset.column
            label {{ t.community_manager }}
            select(v-model="data.community_manager" style="width: 200px;")
              option(v-for="cm in $root.users.filter(d => ['admin', 'community_manager'].includes(d.role)).map((v, k) => Object.assign({id: k},v)).vls()" :value="cm.id") {{ cm.name }}
        .actions.row.right.center(@click.stop="close")
          button.red(v-if="$root.admin && name === 'edit_box_account'" @click.stop.prevent="$root.delete_box_account(data.id)") {{ t.delete_box_account }}
          button.red(@click.stop.prevent="close") {{ t.cancel }}
          button.green(@click.stop.prevent="$root.new_box_account(data)") {{ name === 'box_account' ? t.create_account : t.modify_account }}

    template(v-if="name === 'user' || name === 'edit_user'")
      .admin-modal.column(@click.stop)
        .modal-content
          .header.row.center.right(v-if="$root.mobile")
            .icon.close(@click.stop="close")
              font-awesome-icon(icon="times")
          fieldset.column
            label Nom
            input.text(v-model="data.name")
          fieldset.column
            label Email
            input.text(v-model="data.email" :disabled="name === 'edit_user'")
          fieldset.column
            label Password
            .row(v-if="name === 'edit_user'")
              button(@click="reset_password" :class="[reset ? 'inactive' : 'primary']") {{ reset === 'loading' ? 'Chargement...' : 'Reset password' }}
              .row.center(v-if="reset === 'success'") Email envoyé
            input.text(v-else v-model="data.password")
          .rows
            fieldset.column
              label Role
              select(v-model="data.role" v-if="$root.admin")
                option(:value="undefined" disabled) {{ t.role }}
                option(v-for="opt in ['employee', 'client', 'community_manager', 'admin']" :value="opt") {{ opt.titleize()}}
              .row.center.left(style="min-width: 80px;" v-else) Client
            fieldset.column(v-if="data.role !== 'admin'" style="flex: 1;")
              label {{ t.box_accounts }}
              multi-select(:data="$root.box_accounts.map((v, k) => v.name).vls()" :value="data.box_accounts && data.box_accounts.keys().map(d => $root.box_accounts[d].name) || []" @change="update_box_accounts($event)")
          fieldset.column(v-if="['admin', 'community_manager'].includes(data.role)")
            label Signature HTML
            textarea(v-model="data.signature")
            label Rendu
            div(v-html="data.signature")
        .actions.row.right.center(@click.stop="close")
          button.red(@click.stop.prevent="close") Annuler
          button.green(v-if="name==='user'" @click.stop.prevent="$root.new_user(data).then(() => $root.admin_modal = null)") Ajouter
          button.green(v-if="name==='edit_user'" @click.stop.prevent="$root.edit_user(data).then(() => $root.admin_modal = null)") Modifier
</template>
<script>
export default {
  props: ['data', 'name'],
  data() {
    return {
      reset: false,
    }
  },

  computed: {
  },
  methods: {
    close(){
      this.$root.admin_modal = null
      this.$emit('close')
    },
    reset_password() {
      this.reset = 'loading'
      firebase.auth().sendPasswordResetEmail(this.data.email)
        .then(() => this.reset='success')
        .catch((e) => this.reset = false)
    },
    update_box_accounts(box_account_name) {
      if (!this.$root.box_accounts) return
      const box_account = this.$root.box_accounts[this.$root.box_accounts.find(v => v.name === box_account_name)]
      const box_account_id = box_account.id
      if (!this.data.box_accounts) return Vue.set(this.data, 'box_accounts', {[box_account_id]: true})
      if (this.data.box_accounts[box_account.id]) return Vue.set(this.data, 'box_accounts', this.data.box_accounts.filter((v,k) => k !== box_account.id))
      Vue.set(this.data.box_accounts, box_account.id, true)
    },
    update_users(user_name) {
      const uid = this.$root.users.find(v => v.name === user_name)
      if (!this.data.users) return Vue.set(this.data, 'users', [uid])
      if (this.data.users.includes(uid)) return Vue.set(this.data, 'users', this.data.users.filter(d => d !== uid))
      this.data.users.push(uid)
    },
    upload(ev) {
      this.$root.logo_upload(ev, this.data.id)
        .then(res => {
          console.log('path',res)
          Vue.set(this.data, 'logo', res)
        })
    }
  },
  watch: {
  }
}
</script>
<style>

.admin-modal {
  position:fixed;
  left: calc(50vw - 300px);
  top: calc(50vh - 310px);
  width: 600px;

}
.mobile:not(.laptop) .admin-modal {
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  /* padding-bottom: 72px; */
  border-radius: 0;
  z-index: 104;
}
.mobile:not(.laptop) .admin-modal .modal-content {
  height: calc(100vh - 60px);
  max-height: inherit;
}
.mobile:not(.laptop) .admin-modal .actions button {
  height: 100%;
}
.admin-modal .modal-content {
  background: var(--background);
  padding: 16px;
  border-radius: 8px;
  max-height: 620px;
  overflow-y: scroll;

}
.admin-modal fieldset {
  margin-bottom: 12px;
}
.admin-modal .account-logo  {
  margin-right: 16px;
}
.admin-modal fieldset input.text {
  height: 36px;
  width: 260px;

}
.admin-modal select {
  height: 36px;
  width: 120px;
}
.admin-modal fieldset input, .admin-modal select, .admin-modal fieldset textarea {
  background: white;
  font-size: 14px;
}
.admin-modal .targets .icon {
  width: 24px;
  height: 24px;
  margin-left: 8px;
}
.admin-modal fieldset textarea {
  width: 100%;
  height: 80px;
}
.admin-modal fieldset input[disabled] {
  background: var(--lightgrey);
}
.admin-modal fieldset label {
  font-size: 16px;
  margin-bottom: 8px
}

.admin-modal-backdrop .actions {
  padding: 12px 16px;
}
.admin-modal-backdrop .actions button {
  margin-left: 16px;
  box-shadow: var(--box-shadow);
}
.admin-modal-backdrop .actions button:active {
  box-shadow: none;
}

.mobile:not(.laptop) .admin-modal .header .icon {
  height: 38px;
  width: 38px;
  margin-left: 8px;
  padding: 9px;
  border-radius: 50%;
  color: var(--text);
  background: white;
}
.admin-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right:0;
  bottom:0;
  background: rgba(0,0,0,0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 104;
}
.modal-fade-enter, .modal-fade-leave-active { opacity: 0; }
.modal-fade-enter-active, .modal-fade-leave-active { transition: opacity 0.2s ease-in-out; }
</style>
